import { SEND_API_SETTINGS, SEND_API_SETTINGS_SUCCESS,
    GET_API_SETTINGS, GET_API_SETTINGS_SUCCESS, PUT_API_KEY,
    PUT_API_KEY_SUCCESS, API_ZAPIER_DISCONNECT,
    API_ZAPIER_DISCONNECT_SUCCESS } from './constants';

/**
 *
 * @param form
 * @returns {{form: *, type: string}}
 */
const sendApiSettings = ( form ) => ( {
    type: SEND_API_SETTINGS,
    form
} );

/**
 *
 * @param result
 * @returns {{result: *, type: string}}
 */
const sendApiSettingsSuccess = ( result ) => ( {
    type: SEND_API_SETTINGS_SUCCESS,
    result
} );

/**
 *
 * @param form
 * @returns {{form: *, type: string}}
 */
const getApiSettings = ( form ) => ( {
    type: GET_API_SETTINGS,
    form
} );

/**
 *
 * @param result
 * @returns {{result: *, type: string}}
 */
const getApiSettingsSuccess = ( result ) => ( {
    type: GET_API_SETTINGS_SUCCESS,
    result
} );

/**
 *
 * @returns {{type: string}}
 */
const putApiKey = () => ({ type: PUT_API_KEY });

/**
 *
 * @param result
 * @returns {{result: *, type: string}}
 */
const putApiKeySuccess = ( result ) =>({
    type: PUT_API_KEY_SUCCESS,
    result
});

/**
 *
 * @returns {{type: string}}
 */
const putApiZapierDisconnect = () => ({
    type:  API_ZAPIER_DISCONNECT
});

/**
 *
 * @param result
 * @returns {{result: *, type: string}}
 */
const putApiZapierDisconnectSuccess = ( result ) =>({
    type: API_ZAPIER_DISCONNECT_SUCCESS,
    result
});

export { sendApiSettings, sendApiSettingsSuccess, getApiSettings, getApiSettingsSuccess, putApiKey, putApiKeySuccess,  putApiZapierDisconnect, putApiZapierDisconnectSuccess  };